"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postContact = exports.getPosts = exports.getPost = exports.getAllPages = exports.getPage = exports.getSite = void 0;
const qs_1 = __importDefault(require("qs"));
const utility_1 = require("./utility");
const utilityTypes_1 = require("../utilityTypes");
const config = __importStar(require("../config"));
const BACK_URL = process.env.REACT_APP_BACK_URL ??
    `https://${config.SITE_CONFIG_BY_SITE_NAME[process.env.REACT_APP_SITE_NAME].back.domain}`;
// For some reason, Strapi's auto-generated types don't have the correct formats type
const fromStrapiUpload = (apiUpload) => flattenData(apiUpload);
const fromStrapiUploads = (data) => data?.data.map(fromStrapiUpload);
const flattenData = (data) => ({
    id: data.id,
    ...data.attributes,
});
const flattenResponseCollection = (data) => data?.data.map(flattenData);
const fromStrapiPageAttributes = (page) => {
    return {
        ...page,
        file: page.file?.data ? fromStrapiUpload(page.file.data) : undefined,
        widgetsMain: fromStrapiWidgets(page.widgetsMain),
        widgetsLeft: fromStrapiWidgets(page.widgetsLeft),
        widgetsRight: fromStrapiWidgets(page.widgetsRight),
    };
};
const fromStrapiPage = (apiPage) => fromStrapiPageAttributes(flattenData(apiPage.data));
const fromStrapiSiteData = (data) => {
    const siteAttributes = data.attributes;
    return {
        ...siteAttributes,
        socials: flattenResponseCollection(siteAttributes.socials),
        navTopPages: flattenResponseCollection(siteAttributes.navTopPages)?.map((p) => ({
            ...p,
            file: p.file?.data && flattenData(p.file.data),
            widgetsMain: p.widgetsMain && fromStrapiWidgets(p.widgetsMain),
        })),
        vanityPaths: siteAttributes.vanityPaths?.map((vp) => ({
            ...vp,
            page: vp.page?.data &&
                (() => {
                    const data = flattenData(vp.page.data);
                    return data;
                })(),
            post: vp.post?.data &&
                (() => {
                    const data = flattenData(vp.post.data);
                    return data;
                })(),
        })),
        globalFooterWidgets: siteAttributes.globalFooterWidgets &&
            fromStrapiWidgets(siteAttributes.globalFooterWidgets),
    };
};
const fromStrapiPostAttributes = (post) => {
    return {
        ...post,
        cover: post.cover?.data && fromStrapiUpload(post.cover.data),
        postType: post.postType?.[0],
        links: post?.links,
        widgetsMain: fromStrapiPostWidgets(post.widgetsMain),
    };
};
const fromStrapiPost = (apiPost) => fromStrapiPostAttributes(flattenData(apiPost.data));
const fromStrapiWidgets = (apiWidgets) => {
    return apiWidgets?.map((apiWidget) => {
        switch (apiWidget.__component) {
            case 'widget.links':
            case 'widget.rich-text-block':
            case 'widget.socials':
            case 'widget.timeline':
            case 'widget.contact-form':
                return apiWidget;
            case 'widget.image':
                return {
                    ...apiWidget,
                    image: apiWidget.image ? fromStrapiUpload(apiWidget.image.data) : undefined,
                };
            case 'widget.posts':
            case 'widget.post-list':
            case 'widget.post-grid':
                return {
                    ...apiWidget,
                    posts: flattenResponseCollection(apiWidget.posts)?.map(fromStrapiPostAttributes),
                };
            case 'widget.gallery':
                return {
                    ...apiWidget,
                    media: fromStrapiUploads(apiWidget.media),
                };
            default:
                return (0, utilityTypes_1.staticAssertNever)(apiWidget);
        }
    });
};
const fromStrapiPostWidgets = (apiWidgets) => {
    return apiWidgets?.map((apiWidget) => {
        switch (apiWidget.__component) {
            case 'widget.links':
            case 'widget.rich-text-block':
            case 'widget.socials':
            case 'widget.timeline':
            case 'widget.contact-form':
                return apiWidget;
            case 'widget.image':
                return {
                    ...apiWidget,
                    image: apiWidget.image ? fromStrapiUpload(apiWidget.image.data) : undefined,
                };
            case 'widget.gallery':
                return {
                    ...apiWidget,
                    media: fromStrapiUploads(apiWidget.media),
                };
            case 'widget.posts':
            case 'widget.post-grid':
            case 'widget.post-list':
                // breaks type system to do this; I don't think it's really necessary anyway
                throw Error('No nested Posts');
            default:
                return (0, utilityTypes_1.staticAssertNever)(apiWidget);
        }
    });
};
const defaultPagination = {
    pageSize: 1000,
};
const widgetsParams = {
    pagination: defaultPagination,
    fields: '*',
    populate: {
        posts: {
            fields: '*',
            populate: {
                cover: {
                    fields: '*',
                },
            },
        },
        image: '*',
        events: '*',
        format: '*',
        media: '*',
    },
};
const siteFields = ['title', 'name'];
const sitePopulate = {
    navTopPages: {
        pagination: defaultPagination,
        fields: ['title', 'slug'],
        populate: {
            file: '*',
            // Get the top widgets so the slug can be determined for post pages (see index.tsx:122)
            widgetsMain: {
                pagination: defaultPagination,
                populate: {
                    posts: '*',
                },
            },
        },
    },
    socials: {
        pagination: defaultPagination,
        fields: ['type', 'url'],
    },
    vanityPaths: {
        pagination: defaultPagination,
        populate: {
            page: '*',
            post: {
                fields: ['title', 'slug'],
            },
        }
    },
    globalFooterWidgets: widgetsParams,
};
const getSite = async () => {
    const params = qs_1.default.stringify({
        fields: siteFields,
        populate: sitePopulate,
    }, { encodeValuesOnly: true });
    const apiSite = await (0, utility_1.fetchSingle)(`${BACK_URL}/api/site?${params}`);
    return fromStrapiSiteData(apiSite.data);
};
exports.getSite = getSite;
const getPage = async (slug) => {
    const params = qs_1.default.stringify({
        filters: {
            slug: {
                $eq: slug,
            },
        },
        fields: '*',
        populate: {
            widgetsMain: widgetsParams,
            widgetsLeft: widgetsParams,
            widgetsRight: widgetsParams,
        },
    }, { encodeValuesOnly: true });
    const apiPage = await (0, utility_1.fetchCollection)(`${BACK_URL}/api/pages?${params}`);
    return flattenResponseCollection(apiPage)?.map(fromStrapiPageAttributes)[0];
};
exports.getPage = getPage;
const getAllPages = async () => {
    const params = qs_1.default.stringify({
        pagination: defaultPagination,
        fields: '*',
    }, { encodeValuesOnly: true });
    const apiPages = await (0, utility_1.fetchCollection)(`${BACK_URL}/api/pages?${params}`);
    return flattenResponseCollection(apiPages)?.map(fromStrapiPageAttributes);
};
exports.getAllPages = getAllPages;
const getPost = async (idOrSlug) => {
    const [id, slug] = typeof idOrSlug === 'string' ? [undefined, idOrSlug] : [idOrSlug, undefined];
    const params = {
        fields: '*',
        populate: {
            cover: '*',
            links: {
                pagination: defaultPagination,
                fields: '*',
                populate: {
                    links: {
                        fields: '*',
                    },
                },
            },
            postType: {
                pagination: defaultPagination,
                populate: {
                    episodes: '*',
                },
            },
            widgetsMain: widgetsParams,
        },
    };
    if (id !== undefined) {
        const apiPost = await (0, utility_1.fetchSingle)(`${BACK_URL}/api/posts/${id}?${qs_1.default.stringify(params, { encodeValuesOnly: true })}`);
        return fromStrapiPost(apiPost);
    }
    const slugParams = {
        ...params,
        filters: {
            slug: {
                $eq: slug,
            },
        },
    };
    const apiPosts = await (0, utility_1.fetchCollection)(`${BACK_URL}/api/posts?${qs_1.default.stringify(slugParams, { encodeValuesOnly: true })}`);
    return flattenResponseCollection(apiPosts)?.map(fromStrapiPostAttributes)[0];
};
exports.getPost = getPost;
const sortCompare = (a, b) => {
    if (a === undefined) {
        return b === undefined ? 0 : -1;
    }
    if (b === undefined) {
        return 1;
    }
    if (typeof a === 'string') {
        // split out leading number if it exists and try to sort by that first
        // (this prevents '10' from coming before '2')
        const aNum = parseInt(a);
        const bNum = parseInt(b);
        if (!isNaN(aNum) && !isNaN(bNum)) {
            if (aNum !== bNum) {
                return aNum - bNum;
            }
        }
        return a.localeCompare(b);
    }
    return a - b;
};
const getPosts = async (sorts) => {
    const params = qs_1.default.stringify({
        pagination: defaultPagination,
        sort: sorts
            ? sorts.map((sort) => `${sort.field}:${sort.isAsc ? 'asc' : 'desc'}`)
            : [],
        fields: '*',
        populate: '*',
    }, { encodeValuesOnly: true });
    const apiPosts = await (0, utility_1.fetchCollection)(`${BACK_URL}/api/posts?${params}`);
    return flattenResponseCollection(apiPosts)?.map(fromStrapiPostAttributes).sort((a, b) => {
        if (sorts) {
            for (const sort of sorts) {
                // @ts-ignore
                const result = sortCompare(a[sort.field], b[sort.field]);
                if (result !== 0) {
                    return (sort.isAsc ? 1 : -1) * result;
                }
            }
        }
        return 0;
    });
};
exports.getPosts = getPosts;
const postContact = async (data) => {
    const response = await fetch(`${BACK_URL}/api/contacts`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ data }),
    });
    return { success: response.ok, error: !response.ok ? await response.text() : undefined };
};
exports.postContact = postContact;
